import { createContext } from 'react';

import type { LoginPayload, Membership, Organization, RegisterPayload, User } from '@/types/api';

export interface AuthContextValue {
  user: User | null;
  memberships: Membership[];
  activeOrganization: Organization | null;
  activeRole: string | null;
  /** Permissions in the active organisation, as resolved by the server. */
  permissions: string[];
  isLoading: boolean;
  isAuthenticated: boolean;
  login: (payload: LoginPayload) => Promise<void>;
  register: (payload: RegisterPayload) => Promise<void>;
  logout: () => Promise<void>;
  switchOrganization: (organizationId: string) => Promise<void>;
}

/**
 * Context and types live here, apart from the provider component.
 *
 * A module that exports both a component and a non-component loses Vite fast
 * refresh entirely — every edit becomes a full page reload.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);

export const SESSION_QUERY_KEY = ['auth', 'session'] as const;
